module.exports = __webpack_public_path__ + "static/media/patvirtinkite_paraiska.aa2d33e9.png";